import React, { useState, useEffect } from 'react';
import { ROLES } from '../utils/roles';
import './ContactModal.css';

// Definer de faste roller her
const PREDEFINED_ROLES = [
  'Prøveansvarlig',
  'Kontaktperson',
  'Prøveansvarlig 2',
  'Souschef',
  'Administrativ medarbejder',
  'Forstander',
  'Modultest ansvarlig'
];

const ContactModal = ({ contact, isOpen, onClose, onSave, onDelete, user, centers }) => {
  
  const defaultScId = user.role === ROLES.SC_ADMIN ? user.scId : '';
  
  const [formData, setFormData] = useState({
    navn: '',
    rolle: '',
    email: '',
    telefon: '',
    sprogcenter_id: defaultScId
  });

  useEffect(() => {
    if (contact) {
      setFormData({
        navn: contact.navn || '',
        rolle: contact.rolle || '', // Hvis den eksisterende rolle ikke er i listen, vises den stadig som selected hvis vi ikke passer på, men HTML select kan drille med custom values.
                                    // Med denne løsning vil en "ugyldig" gammel rolle vise "Vælg rolle", medmindre vi tilføjer den dynamisk.
                                    // For nu antager vi at du rydder op eller vælger en ny.
        email: contact.email || '',
        telefon: contact.telefon || '',
        sprogcenter_id: contact.sprogcenter_id || defaultScId
      });
    } else {
      setFormData({
        navn: '',
        rolle: '', // Default tom
        email: '',
        telefon: '',
        sprogcenter_id: defaultScId
      });
    }
  }, [contact, user, defaultScId, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user.role === ROLES.ADMIN && !formData.sprogcenter_id) {
      alert('Vælg venligst et sprogcenter');
      return;
    }
    onSave({ ...formData, id: contact?.id });
  };

  const handleDeleteClick = () => {
    if (window.confirm(`Er du sikker på at du vil slette ${formData.navn}?`)) {
      onDelete(contact.id);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        
        <div className="modal-header">
          <h2 className="modal-title">{contact ? 'Rediger Kontakt' : 'Opret Ny Kontakt'}</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          
          {user.role === ROLES.ADMIN && (
            <div className="form-group">
              <label>Tilhører Sprogcenter</label>
              <select 
                name="sprogcenter_id" 
                value={formData.sprogcenter_id} 
                onChange={handleChange}
                style={{border: '2px solid #003366', background: '#f0f4f8'}}
              >
                <option value="">-- Vælg Sprogcenter --</option>
                {centers.map(sc => (
                  <option key={sc.id} value={sc.id}>{sc.navn}</option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Navn</label>
            <input name="navn" value={formData.navn} onChange={handleChange} required placeholder="F.eks. Jens Jensen" />
          </div>

          {/* ÆNDRET HER: Fra Input til Select */}
          <div className="form-group">
            <label>Rolle / Titel</label>
            <select 
              name="rolle" 
              value={formData.rolle} 
              onChange={handleChange} 
              required
              style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px'}}
            >
              <option value="">-- Vælg Rolle --</option>
              {PREDEFINED_ROLES.map((role) => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="mail@skole.dk" />
          </div>

          <div className="form-group">
            <label>Telefon</label>
            <input name="telefon" value={formData.telefon} onChange={handleChange} placeholder="12 34 56 78" />
          </div>

          <div className="modal-footer">
            {contact ? (
              <button type="button" className="btn-delete" onClick={handleDeleteClick}>Slet</button>
            ) : <div></div>}

            <div className="modal-actions">
              <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
              <button type="submit" className="btn-save">{contact ? 'Gem Ændringer' : 'Opret Kontakt'}</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ContactModal;